import { render, staticRenderFns } from "./ListSensorOnOff.vue?vue&type=template&id=13f637de&scoped=true"
import script from "./ListSensorOnOff.vue?vue&type=script&lang=js"
export * from "./ListSensorOnOff.vue?vue&type=script&lang=js"
import style0 from "./ListSensorOnOff.vue?vue&type=style&index=0&id=13f637de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f637de",
  null
  
)

export default component.exports